const o = "propChange/HIST_FILE_UPLOAD";
export {
  o as CHANGE_PROP
};
//# sourceMappingURL=types.js.map
